module.exports = __webpack_public_path__ + "static/Canada-498e82078e89bc3b6a0a391b68bd2662.jpg";